import { render, staticRenderFns } from "./integrations-read-more.vue?vue&type=template&id=35e43fec&"
import script from "./integrations-read-more.vue?vue&type=script&lang=js&"
export * from "./integrations-read-more.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports